


























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ModalDialog extends Vue {
  @Prop() title!: string;
  @Prop() text!: string;
  @Prop() buttonText!: string;
  @Prop() isDanger!: boolean;
  

  respect = false;

  onClose() {
    this.$emit("closed");
  }

  onButton() {
    this.$emit("button");
  }

  onRespect(e: KeyboardEvent): boolean {
    if (e.key === "f" || e.key === "F") {
      this.respect = true;
    }
    return true;
  }

  get thetext(): string {
    if (this.respect) {
      return "Respect paid. Thank you.";
    } else {
      return this.text;
    }
  }
}
